export default "__VITE_ASSET__Dk6ceHzh__"